/**
 * Generated static importers for the temp logo editor.
 *
 * Concrete import strings keep Atlaspack/Parcel from dropping the icon modules
 * when the picker catalog is loaded from metadata at runtime.
 */

export const coreIconImporters: Record<string, () => Promise<{ default: any }>> = {
	accessibility: () => import('@atlaskit/icon/core/accessibility'),
	add: () => import('@atlaskit/icon/core/add'),
	'ai-agent': () => import('@atlaskit/icon/core/ai-agent'),
	'ai-chat': () => import('@atlaskit/icon/core/ai-chat'),
	'ai-generative-text-summary': () => import('@atlaskit/icon/core/ai-generative-text-summary'),
	'ai-sparkle': () => import('@atlaskit/icon/core/ai-sparkle'),
	alert: () => import('@atlaskit/icon/core/alert'),
	'align-image-center': () => import('@atlaskit/icon/core/align-image-center'),
	'align-image-left': () => import('@atlaskit/icon/core/align-image-left'),
	'align-image-right': () => import('@atlaskit/icon/core/align-image-right'),
	'align-text-center': () => import('@atlaskit/icon/core/align-text-center'),
	'align-text-left': () => import('@atlaskit/icon/core/align-text-left'),
	'align-text-right': () => import('@atlaskit/icon/core/align-text-right'),
	'angle-brackets': () => import('@atlaskit/icon/core/angle-brackets'),
	api: () => import('@atlaskit/icon/core/api'),
	'app-switcher-legacy': () => import('@atlaskit/icon/core/app-switcher-legacy'),
	'app-switcher': () => import('@atlaskit/icon/core/app-switcher'),
	app: () => import('@atlaskit/icon/core/app'),
	apps: () => import('@atlaskit/icon/core/apps'),
	'archive-box': () => import('@atlaskit/icon/core/archive-box'),
	'arrow-down-left': () => import('@atlaskit/icon/core/arrow-down-left'),
	'arrow-down-right': () => import('@atlaskit/icon/core/arrow-down-right'),
	'arrow-down': () => import('@atlaskit/icon/core/arrow-down'),
	'arrow-left': () => import('@atlaskit/icon/core/arrow-left'),
	'arrow-right': () => import('@atlaskit/icon/core/arrow-right'),
	'arrow-up-left': () => import('@atlaskit/icon/core/arrow-up-left'),
	'arrow-up-right': () => import('@atlaskit/icon/core/arrow-up-right'),
	'arrow-up': () => import('@atlaskit/icon/core/arrow-up'),
	assets: () => import('@atlaskit/icon/core/assets'),
	'atlassian-intelligence': () => import('@atlaskit/icon/core/atlassian-intelligence'),
	attachment: () => import('@atlaskit/icon/core/attachment'),
	audio: () => import('@atlaskit/icon/core/audio'),
	automation: () => import('@atlaskit/icon/core/automation'),
	backlog: () => import('@atlaskit/icon/core/backlog'),
	basketball: () => import('@atlaskit/icon/core/basketball'),
	board: () => import('@atlaskit/icon/core/board'),
	boards: () => import('@atlaskit/icon/core/boards'),
	'book-with-bookmark': () => import('@atlaskit/icon/core/book-with-bookmark'),
	border: () => import('@atlaskit/icon/core/border'),
	branch: () => import('@atlaskit/icon/core/branch'),
	briefcase: () => import('@atlaskit/icon/core/briefcase'),
	bug: () => import('@atlaskit/icon/core/bug'),
	'calendar-plus': () => import('@atlaskit/icon/core/calendar-plus'),
	calendar: () => import('@atlaskit/icon/core/calendar'),
	camera: () => import('@atlaskit/icon/core/camera'),
	capture: () => import('@atlaskit/icon/core/capture'),
	card: () => import('@atlaskit/icon/core/card'),
	cash: () => import('@atlaskit/icon/core/cash'),
	changes: () => import('@atlaskit/icon/core/changes'),
	'chart-bar': () => import('@atlaskit/icon/core/chart-bar'),
	'chart-bubble': () => import('@atlaskit/icon/core/chart-bubble'),
	'chart-matrix': () => import('@atlaskit/icon/core/chart-matrix'),
	'chart-pie': () => import('@atlaskit/icon/core/chart-pie'),
	'chart-trend-down': () => import('@atlaskit/icon/core/chart-trend-down'),
	'chart-trend-up': () => import('@atlaskit/icon/core/chart-trend-up'),
	'chart-trend': () => import('@atlaskit/icon/core/chart-trend'),
	'chat-widget': () => import('@atlaskit/icon/core/chat-widget'),
	'check-circle-unchecked': () => import('@atlaskit/icon/core/check-circle-unchecked'),
	'check-circle': () => import('@atlaskit/icon/core/check-circle'),
	'check-mark': () => import('@atlaskit/icon/core/check-mark'),
	'checkbox-checked': () => import('@atlaskit/icon/core/checkbox-checked'),
	'checkbox-indeterminate': () => import('@atlaskit/icon/core/checkbox-indeterminate'),
	'checkbox-unchecked': () => import('@atlaskit/icon/core/checkbox-unchecked'),
	'chevron-double-left': () => import('@atlaskit/icon/core/chevron-double-left'),
	'chevron-double-right': () => import('@atlaskit/icon/core/chevron-double-right'),
	'chevron-down': () => import('@atlaskit/icon/core/chevron-down'),
	'chevron-left': () => import('@atlaskit/icon/core/chevron-left'),
	'chevron-right': () => import('@atlaskit/icon/core/chevron-right'),
	'chevron-up': () => import('@atlaskit/icon/core/chevron-up'),
	'child-work-items': () => import('@atlaskit/icon/core/child-work-items'),
	clipboard: () => import('@atlaskit/icon/core/clipboard'),
	clock: () => import('@atlaskit/icon/core/clock'),
	close: () => import('@atlaskit/icon/core/close'),
	'cloud-arrow-up': () => import('@atlaskit/icon/core/cloud-arrow-up'),
	'collapse-horizontal': () => import('@atlaskit/icon/core/collapse-horizontal'),
	'collapse-vertical': () => import('@atlaskit/icon/core/collapse-vertical'),
	'comment-add': () => import('@atlaskit/icon/core/comment-add'),
	comment: () => import('@atlaskit/icon/core/comment'),
	commit: () => import('@atlaskit/icon/core/commit'),
	compass: () => import('@atlaskit/icon/core/compass'),
	component: () => import('@atlaskit/icon/core/component'),
	'content-width-narrow': () => import('@atlaskit/icon/core/content-width-narrow'),
	'content-width-wide': () => import('@atlaskit/icon/core/content-width-wide'),
	'content-wrap-left': () => import('@atlaskit/icon/core/content-wrap-left'),
	'content-wrap-right': () => import('@atlaskit/icon/core/content-wrap-right'),
	copy: () => import('@atlaskit/icon/core/copy'),
	'credit-card': () => import('@atlaskit/icon/core/credit-card'),
	'cross-circle': () => import('@atlaskit/icon/core/cross-circle'),
	cross: () => import('@atlaskit/icon/core/cross'),
	'curly-brackets': () => import('@atlaskit/icon/core/curly-brackets'),
	customize: () => import('@atlaskit/icon/core/customize'),
	dashboard: () => import('@atlaskit/icon/core/dashboard'),
	'data-flow': () => import('@atlaskit/icon/core/data-flow'),
	'data-number': () => import('@atlaskit/icon/core/data-number'),
	'data-string': () => import('@atlaskit/icon/core/data-string'),
	database: () => import('@atlaskit/icon/core/database'),
	decision: () => import('@atlaskit/icon/core/decision'),
	defect: () => import('@atlaskit/icon/core/defect'),
	delete: () => import('@atlaskit/icon/core/delete'),
	department: () => import('@atlaskit/icon/core/department'),
	'device-mobile': () => import('@atlaskit/icon/core/device-mobile'),
	devices: () => import('@atlaskit/icon/core/devices'),
	discovery: () => import('@atlaskit/icon/core/discovery'),
	download: () => import('@atlaskit/icon/core/download'),
	'drag-handle-horizontal': () => import('@atlaskit/icon/core/drag-handle-horizontal'),
	'drag-handle-vertical': () => import('@atlaskit/icon/core/drag-handle-vertical'),
	'edit-bulk': () => import('@atlaskit/icon/core/edit-bulk'),
	edit: () => import('@atlaskit/icon/core/edit'),
	email: () => import('@atlaskit/icon/core/email'),
	'emoji-add': () => import('@atlaskit/icon/core/emoji-add'),
	'emoji-casual': () => import('@atlaskit/icon/core/emoji-casual'),
	'emoji-neutral': () => import('@atlaskit/icon/core/emoji-neutral'),
	'emoji-remove': () => import('@atlaskit/icon/core/emoji-remove'),
	emoji: () => import('@atlaskit/icon/core/emoji'),
	epic: () => import('@atlaskit/icon/core/epic'),
	error: () => import('@atlaskit/icon/core/error'),
	'exclamation-square': () => import('@atlaskit/icon/core/exclamation-square'),
	'expand-horizontal': () => import('@atlaskit/icon/core/expand-horizontal'),
	'expand-vertical': () => import('@atlaskit/icon/core/expand-vertical'),
	'eye-open-filled': () => import('@atlaskit/icon/core/eye-open-filled'),
	'eye-open-strikethrough': () => import('@atlaskit/icon/core/eye-open-strikethrough'),
	'eye-open': () => import('@atlaskit/icon/core/eye-open'),
	feed: () => import('@atlaskit/icon/core/feed'),
	feedback: () => import('@atlaskit/icon/core/feedback'),
	'field-alert': () => import('@atlaskit/icon/core/field-alert'),
	'field-checkbox-group': () => import('@atlaskit/icon/core/field-checkbox-group'),
	'field-dropdown': () => import('@atlaskit/icon/core/field-dropdown'),
	'field-radio-group': () => import('@atlaskit/icon/core/field-radio-group'),
	field: () => import('@atlaskit/icon/core/field'),
	file: () => import('@atlaskit/icon/core/file'),
	files: () => import('@atlaskit/icon/core/files'),
	filter: () => import('@atlaskit/icon/core/filter'),
	'flag-filled': () => import('@atlaskit/icon/core/flag-filled'),
	flag: () => import('@atlaskit/icon/core/flag'),
	flask: () => import('@atlaskit/icon/core/flask'),
	'focus-area': () => import('@atlaskit/icon/core/focus-area'),
	'folder-closed': () => import('@atlaskit/icon/core/folder-closed'),
	'folder-open': () => import('@atlaskit/icon/core/folder-open'),
	form: () => import('@atlaskit/icon/core/form'),
	'fullscreen-enter': () => import('@atlaskit/icon/core/fullscreen-enter'),
	'fullscreen-exit': () => import('@atlaskit/icon/core/fullscreen-exit'),
	glasses: () => import('@atlaskit/icon/core/glasses'),
	globe: () => import('@atlaskit/icon/core/globe'),
	goal: () => import('@atlaskit/icon/core/goal'),
	grid: () => import('@atlaskit/icon/core/grid'),
	'grow-diagonal': () => import('@atlaskit/icon/core/grow-diagonal'),
	'grow-horizontal': () => import('@atlaskit/icon/core/grow-horizontal'),
	'grow-vertical': () => import('@atlaskit/icon/core/grow-vertical'),
	hashtag: () => import('@atlaskit/icon/core/hashtag'),
	headphones: () => import('@atlaskit/icon/core/headphones'),
	heart: () => import('@atlaskit/icon/core/heart'),
	highlight: () => import('@atlaskit/icon/core/highlight'),
	home: () => import('@atlaskit/icon/core/home'),
	'image-fullscreen': () => import('@atlaskit/icon/core/image-fullscreen'),
	'image-inline': () => import('@atlaskit/icon/core/image-inline'),
	'image-scaled': () => import('@atlaskit/icon/core/image-scaled'),
	image: () => import('@atlaskit/icon/core/image'),
	inbox: () => import('@atlaskit/icon/core/inbox'),
	incident: () => import('@atlaskit/icon/core/incident'),
	'information-circle': () => import('@atlaskit/icon/core/information-circle'),
	information: () => import('@atlaskit/icon/core/information'),
	'key-result': () => import('@atlaskit/icon/core/key-result'),
	'layout-one-column': () => import('@atlaskit/icon/core/layout-one-column'),
	'layout-three-columns-sidebars': () =>
		import('@atlaskit/icon/core/layout-three-columns-sidebars'),
	'layout-three-columns': () => import('@atlaskit/icon/core/layout-three-columns'),
	'layout-two-columns-sidebar-left': () =>
		import('@atlaskit/icon/core/layout-two-columns-sidebar-left'),
	'layout-two-columns-sidebar-right': () =>
		import('@atlaskit/icon/core/layout-two-columns-sidebar-right'),
	'layout-two-columns': () => import('@atlaskit/icon/core/layout-two-columns'),
	library: () => import('@atlaskit/icon/core/library'),
	lightbulb: () => import('@atlaskit/icon/core/lightbulb'),
	'link-broken': () => import('@atlaskit/icon/core/link-broken'),
	'link-external': () => import('@atlaskit/icon/core/link-external'),
	link: () => import('@atlaskit/icon/core/link'),
	'list-bulleted': () => import('@atlaskit/icon/core/list-bulleted'),
	'list-checklist': () => import('@atlaskit/icon/core/list-checklist'),
	'list-numbered': () => import('@atlaskit/icon/core/list-numbered'),
	'lobby-bell': () => import('@atlaskit/icon/core/lobby-bell'),
	location: () => import('@atlaskit/icon/core/location'),
	'lock-locked': () => import('@atlaskit/icon/core/lock-locked'),
	'lock-unlocked': () => import('@atlaskit/icon/core/lock-unlocked'),
	'log-in': () => import('@atlaskit/icon/core/log-in'),
	'log-out': () => import('@atlaskit/icon/core/log-out'),
	'magic-wand': () => import('@atlaskit/icon/core/magic-wand'),
	markdown: () => import('@atlaskit/icon/core/markdown'),
	marketplace: () => import('@atlaskit/icon/core/marketplace'),
	maximize: () => import('@atlaskit/icon/core/maximize'),
	megaphone: () => import('@atlaskit/icon/core/megaphone'),
	mention: () => import('@atlaskit/icon/core/mention'),
	menu: () => import('@atlaskit/icon/core/menu'),
	'merge-failure': () => import('@atlaskit/icon/core/merge-failure'),
	'merge-success': () => import('@atlaskit/icon/core/merge-success'),
	microphone: () => import('@atlaskit/icon/core/microphone'),
	minimize: () => import('@atlaskit/icon/core/minimize'),
	'minus-square': () => import('@atlaskit/icon/core/minus-square'),
	minus: () => import('@atlaskit/icon/core/minus'),
	node: () => import('@atlaskit/icon/core/node'),
	note: () => import('@atlaskit/icon/core/note'),
	'notification-muted': () => import('@atlaskit/icon/core/notification-muted'),
	notification: () => import('@atlaskit/icon/core/notification'),
	objective: () => import('@atlaskit/icon/core/objective'),
	'office-building': () => import('@atlaskit/icon/core/office-building'),
	'on-call': () => import('@atlaskit/icon/core/on-call'),
	operations: () => import('@atlaskit/icon/core/operations'),
	page: () => import('@atlaskit/icon/core/page'),
	pages: () => import('@atlaskit/icon/core/pages'),
	'paint-bucket': () => import('@atlaskit/icon/core/paint-bucket'),
	'paint-palette': () => import('@atlaskit/icon/core/paint-palette'),
	'panel-left': () => import('@atlaskit/icon/core/panel-left'),
	'panel-right': () => import('@atlaskit/icon/core/panel-right'),
	pen: () => import('@atlaskit/icon/core/pen'),
	'people-group': () => import('@atlaskit/icon/core/people-group'),
	'person-add': () => import('@atlaskit/icon/core/person-add'),
	'person-added': () => import('@atlaskit/icon/core/person-added'),
	'person-avatar': () => import('@atlaskit/icon/core/person-avatar'),
	'person-offboard': () => import('@atlaskit/icon/core/person-offboard'),
	'person-remove': () => import('@atlaskit/icon/core/person-remove'),
	'person-warning': () => import('@atlaskit/icon/core/person-warning'),
	person: () => import('@atlaskit/icon/core/person'),
	phone: () => import('@atlaskit/icon/core/phone'),
	'pin-filled': () => import('@atlaskit/icon/core/pin-filled'),
	pin: () => import('@atlaskit/icon/core/pin'),
	'plus-square': () => import('@atlaskit/icon/core/plus-square'),
	'power-plug': () => import('@atlaskit/icon/core/power-plug'),
	premium: () => import('@atlaskit/icon/core/premium'),
	'presenter-mode': () => import('@atlaskit/icon/core/presenter-mode'),
	printer: () => import('@atlaskit/icon/core/printer'),
	'priority-blocker': () => import('@atlaskit/icon/core/priority-blocker'),
	'priority-critical': () => import('@atlaskit/icon/core/priority-critical'),
	'priority-high': () => import('@atlaskit/icon/core/priority-high'),
	'priority-highest': () => import('@atlaskit/icon/core/priority-highest'),
	'priority-low': () => import('@atlaskit/icon/core/priority-low'),
	'priority-lowest': () => import('@atlaskit/icon/core/priority-lowest'),
	'priority-major': () => import('@atlaskit/icon/core/priority-major'),
	'priority-medium': () => import('@atlaskit/icon/core/priority-medium'),
	'priority-minor': () => import('@atlaskit/icon/core/priority-minor'),
	'priority-trivial': () => import('@atlaskit/icon/core/priority-trivial'),
	problem: () => import('@atlaskit/icon/core/problem'),
	'project-status': () => import('@atlaskit/icon/core/project-status'),
	project: () => import('@atlaskit/icon/core/project'),
	'projection-screen': () => import('@atlaskit/icon/core/projection-screen'),
	'pull-request': () => import('@atlaskit/icon/core/pull-request'),
	pulse: () => import('@atlaskit/icon/core/pulse'),
	'question-circle': () => import('@atlaskit/icon/core/question-circle'),
	'quotation-mark': () => import('@atlaskit/icon/core/quotation-mark'),
	'radio-checked': () => import('@atlaskit/icon/core/radio-checked'),
	'radio-unchecked': () => import('@atlaskit/icon/core/radio-unchecked'),
	redo: () => import('@atlaskit/icon/core/redo'),
	refresh: () => import('@atlaskit/icon/core/refresh'),
	release: () => import('@atlaskit/icon/core/release'),
	retry: () => import('@atlaskit/icon/core/retry'),
	roadmap: () => import('@atlaskit/icon/core/roadmap'),
	'rovo-chat': () => import('@atlaskit/icon/core/rovo-chat'),
	scales: () => import('@atlaskit/icon/core/scales'),
	scorecard: () => import('@atlaskit/icon/core/scorecard'),
	'screen-plus': () => import('@atlaskit/icon/core/screen-plus'),
	screen: () => import('@atlaskit/icon/core/screen'),
	search: () => import('@atlaskit/icon/core/search'),
	send: () => import('@atlaskit/icon/core/send'),
	settings: () => import('@atlaskit/icon/core/settings'),
	shapes: () => import('@atlaskit/icon/core/shapes'),
	share: () => import('@atlaskit/icon/core/share'),
	'shield-strikethrough': () => import('@atlaskit/icon/core/shield-strikethrough'),
	shield: () => import('@atlaskit/icon/core/shield'),
	shortcut: () => import('@atlaskit/icon/core/shortcut'),
	'show-more-horizontal': () => import('@atlaskit/icon/core/show-more-horizontal'),
	'show-more-vertical': () => import('@atlaskit/icon/core/show-more-vertical'),
	'shrink-diagonal': () => import('@atlaskit/icon/core/shrink-diagonal'),
	'shrink-horizontal': () => import('@atlaskit/icon/core/shrink-horizontal'),
	'shrink-vertical': () => import('@atlaskit/icon/core/shrink-vertical'),
	'sidebar-collapse': () => import('@atlaskit/icon/core/sidebar-collapse'),
	'sidebar-expand': () => import('@atlaskit/icon/core/sidebar-expand'),
	'smart-link-card': () => import('@atlaskit/icon/core/smart-link-card'),
	'smart-link-embed': () => import('@atlaskit/icon/core/smart-link-embed'),
	'smart-link-inline': () => import('@atlaskit/icon/core/smart-link-inline'),
	'smart-link-list': () => import('@atlaskit/icon/core/smart-link-list'),
	'smart-link': () => import('@atlaskit/icon/core/smart-link'),
	snippet: () => import('@atlaskit/icon/core/snippet'),
	'sort-ascending': () => import('@atlaskit/icon/core/sort-ascending'),
	'sort-descending': () => import('@atlaskit/icon/core/sort-descending'),
	spreadsheet: () => import('@atlaskit/icon/core/spreadsheet'),
	sprint: () => import('@atlaskit/icon/core/sprint'),
	'star-starred': () => import('@atlaskit/icon/core/star-starred'),
	'star-unstarred': () => import('@atlaskit/icon/core/star-unstarred'),
	'status-discovery': () => import('@atlaskit/icon/core/status-discovery'),
	'status-error': () => import('@atlaskit/icon/core/status-error'),
	'status-information': () => import('@atlaskit/icon/core/status-information'),
	'status-success': () => import('@atlaskit/icon/core/status-success'),
	'status-verified': () => import('@atlaskit/icon/core/status-verified'),
	'status-warning': () => import('@atlaskit/icon/core/status-warning'),
	stopwatch: () => import('@atlaskit/icon/core/stopwatch'),
	story: () => import('@atlaskit/icon/core/story'),
	'stroke-weight-extra-large': () => import('@atlaskit/icon/core/stroke-weight-extra-large'),
	'stroke-weight-large': () => import('@atlaskit/icon/core/stroke-weight-large'),
	'stroke-weight-medium': () => import('@atlaskit/icon/core/stroke-weight-medium'),
	'stroke-weight-small': () => import('@atlaskit/icon/core/stroke-weight-small'),
	subtasks: () => import('@atlaskit/icon/core/subtasks'),
	success: () => import('@atlaskit/icon/core/success'),
	support: () => import('@atlaskit/icon/core/support'),
	'table-cell-clear': () => import('@atlaskit/icon/core/table-cell-clear'),
	'table-cell-merge': () => import('@atlaskit/icon/core/table-cell-merge'),
	'table-cell-split': () => import('@atlaskit/icon/core/table-cell-split'),
	'table-column-add-left': () => import('@atlaskit/icon/core/table-column-add-left'),
	'table-column-add-right': () => import('@atlaskit/icon/core/table-column-add-right'),
	'table-column-delete': () => import('@atlaskit/icon/core/table-column-delete'),
	'table-column-move-left': () => import('@atlaskit/icon/core/table-column-move-left'),
	'table-column-move-right': () => import('@atlaskit/icon/core/table-column-move-right'),
	'table-columns-distribute': () => import('@atlaskit/icon/core/table-columns-distribute'),
	'table-row-add-above': () => import('@atlaskit/icon/core/table-row-add-above'),
	'table-row-add-below': () => import('@atlaskit/icon/core/table-row-add-below'),
	'table-row-delete': () => import('@atlaskit/icon/core/table-row-delete'),
	'table-row-move-down': () => import('@atlaskit/icon/core/table-row-move-down'),
	'table-row-move-up': () => import('@atlaskit/icon/core/table-row-move-up'),
	table: () => import('@atlaskit/icon/core/table'),
	tag: () => import('@atlaskit/icon/core/tag'),
	'takeout-food': () => import('@atlaskit/icon/core/takeout-food'),
	target: () => import('@atlaskit/icon/core/target'),
	'task-in-progress': () => import('@atlaskit/icon/core/task-in-progress'),
	'task-to-do': () => import('@atlaskit/icon/core/task-to-do'),
	task: () => import('@atlaskit/icon/core/task'),
	tasks: () => import('@atlaskit/icon/core/tasks'),
	teams: () => import('@atlaskit/icon/core/teams'),
	'text-bold': () => import('@atlaskit/icon/core/text-bold'),
	'text-heading': () => import('@atlaskit/icon/core/text-heading'),
	'text-indent-left': () => import('@atlaskit/icon/core/text-indent-left'),
	'text-indent-right': () => import('@atlaskit/icon/core/text-indent-right'),
	'text-italic': () => import('@atlaskit/icon/core/text-italic'),
	'text-shorten': () => import('@atlaskit/icon/core/text-shorten'),
	'text-spellcheck': () => import('@atlaskit/icon/core/text-spellcheck'),
	'text-strikethrough': () => import('@atlaskit/icon/core/text-strikethrough'),
	'text-style': () => import('@atlaskit/icon/core/text-style'),
	'text-underline': () => import('@atlaskit/icon/core/text-underline'),
	'text-wrap': () => import('@atlaskit/icon/core/text-wrap'),
	text: () => import('@atlaskit/icon/core/text'),
	theme: () => import('@atlaskit/icon/core/theme'),
	'thumbs-down': () => import('@atlaskit/icon/core/thumbs-down'),
	'thumbs-up': () => import('@atlaskit/icon/core/thumbs-up'),
	timeline: () => import('@atlaskit/icon/core/timeline'),
	tools: () => import('@atlaskit/icon/core/tools'),
	transition: () => import('@atlaskit/icon/core/transition'),
	translate: () => import('@atlaskit/icon/core/translate'),
	tree: () => import('@atlaskit/icon/core/tree'),
	undo: () => import('@atlaskit/icon/core/undo'),
	upload: () => import('@atlaskit/icon/core/upload'),
	'vehicle-car': () => import('@atlaskit/icon/core/vehicle-car'),
	'video-next-overlay': () => import('@atlaskit/icon/core/video-next-overlay'),
	'video-next': () => import('@atlaskit/icon/core/video-next'),
	'video-pause-overlay': () => import('@atlaskit/icon/core/video-pause-overlay'),
	'video-pause': () => import('@atlaskit/icon/core/video-pause'),
	'video-play-overlay': () => import('@atlaskit/icon/core/video-play-overlay'),
	'video-play': () => import('@atlaskit/icon/core/video-play'),
	'video-previous-overlay': () => import('@atlaskit/icon/core/video-previous-overlay'),
	'video-previous': () => import('@atlaskit/icon/core/video-previous'),
	'video-skip-backward-fifteen': () => import('@atlaskit/icon/core/video-skip-backward-fifteen'),
	'video-skip-backward-ten': () => import('@atlaskit/icon/core/video-skip-backward-ten'),
	'video-skip-forward-fifteen': () => import('@atlaskit/icon/core/video-skip-forward-fifteen'),
	'video-skip-forward-ten': () => import('@atlaskit/icon/core/video-skip-forward-ten'),
	'video-stop-overlay': () => import('@atlaskit/icon/core/video-stop-overlay'),
	'video-stop': () => import('@atlaskit/icon/core/video-stop'),
	video: () => import('@atlaskit/icon/core/video'),
	'volume-high': () => import('@atlaskit/icon/core/volume-high'),
	'volume-low': () => import('@atlaskit/icon/core/volume-low'),
	'volume-muted': () => import('@atlaskit/icon/core/volume-muted'),
	warning: () => import('@atlaskit/icon/core/warning'),
	whiteboard: () => import('@atlaskit/icon/core/whiteboard'),
	'work-item': () => import('@atlaskit/icon/core/work-item'),
	'work-items': () => import('@atlaskit/icon/core/work-items'),
	'zoom-in': () => import('@atlaskit/icon/core/zoom-in'),
	'zoom-out': () => import('@atlaskit/icon/core/zoom-out'),
};

export const iconLabImporters: Record<string, () => Promise<{ default: any }>> = {
	'ai-bot': () => import('@atlaskit/icon-lab/core/ai-bot'),
	'ai-compute': () => import('@atlaskit/icon-lab/core/ai-compute'),
	'ai-generative-audio-briefing': () =>
		import('@atlaskit/icon-lab/core/ai-generative-audio-briefing'),
	'ai-generative-chapters': () => import('@atlaskit/icon-lab/core/ai-generative-chapters'),
	'ai-generative-cleanup': () => import('@atlaskit/icon-lab/core/ai-generative-cleanup'),
	'ai-generative-remix': () => import('@atlaskit/icon-lab/core/ai-generative-remix'),
	'ai-generative-remove-silence': () =>
		import('@atlaskit/icon-lab/core/ai-generative-remove-silence'),
	'ai-generative-remove': () => import('@atlaskit/icon-lab/core/ai-generative-remove'),
	'ai-generative-slides': () => import('@atlaskit/icon-lab/core/ai-generative-slides'),
	'ai-generative-text-title': () => import('@atlaskit/icon-lab/core/ai-generative-text-title'),
	'ai-generative-text': () => import('@atlaskit/icon-lab/core/ai-generative-text'),
	'ai-model': () => import('@atlaskit/icon-lab/core/ai-model'),
	'ai-search': () => import('@atlaskit/icon-lab/core/ai-search'),
	'align-content-bottom': () => import('@atlaskit/icon-lab/core/align-content-bottom'),
	'align-content-center-horizontal': () =>
		import('@atlaskit/icon-lab/core/align-content-center-horizontal'),
	'align-content-center-vertical': () =>
		import('@atlaskit/icon-lab/core/align-content-center-vertical'),
	'align-content-left': () => import('@atlaskit/icon-lab/core/align-content-left'),
	'align-content-right': () => import('@atlaskit/icon-lab/core/align-content-right'),
	'align-content-top': () => import('@atlaskit/icon-lab/core/align-content-top'),
	'align-position-bottom': () => import('@atlaskit/icon-lab/core/align-position-bottom'),
	'align-position-center-vertical': () =>
		import('@atlaskit/icon-lab/core/align-position-center-vertical'),
	'align-position-top': () => import('@atlaskit/icon-lab/core/align-position-top'),
	'approval-start': () => import('@atlaskit/icon-lab/core/approval-start'),
	'arrow-curved-down-left': () => import('@atlaskit/icon-lab/core/arrow-curved-down-left'),
	'arrow-curved-down-right': () => import('@atlaskit/icon-lab/core/arrow-curved-down-right'),
	'arrow-curved-left-down': () => import('@atlaskit/icon-lab/core/arrow-curved-left-down'),
	'arrow-curved-left-up': () => import('@atlaskit/icon-lab/core/arrow-curved-left-up'),
	'arrow-curved-right-down': () => import('@atlaskit/icon-lab/core/arrow-curved-right-down'),
	'arrow-curved-right-up': () => import('@atlaskit/icon-lab/core/arrow-curved-right-up'),
	'arrow-curved-up-left': () => import('@atlaskit/icon-lab/core/arrow-curved-up-left'),
	'arrow-curved-up-right': () => import('@atlaskit/icon-lab/core/arrow-curved-up-right'),
	'arrow-end': () => import('@atlaskit/icon-lab/core/arrow-end'),
	'arrow-start': () => import('@atlaskit/icon-lab/core/arrow-start'),
	'arrows-diagonal-up-right-down-left': () =>
		import('@atlaskit/icon-lab/core/arrows-diagonal-up-right-down-left'),
	ask: () => import('@atlaskit/icon-lab/core/ask'),
	'assets-data-manager': () => import('@atlaskit/icon-lab/core/assets-data-manager'),
	'assets-graph': () => import('@atlaskit/icon-lab/core/assets-graph'),
	'assets-object-type': () => import('@atlaskit/icon-lab/core/assets-object-type'),
	'assets-object': () => import('@atlaskit/icon-lab/core/assets-object'),
	'assets-schema': () => import('@atlaskit/icon-lab/core/assets-schema'),
	atom: () => import('@atlaskit/icon-lab/core/atom'),
	'audio-waveform': () => import('@atlaskit/icon-lab/core/audio-waveform'),
	'beach-umbrella': () => import('@atlaskit/icon-lab/core/beach-umbrella'),
	'blast-radius': () => import('@atlaskit/icon-lab/core/blast-radius'),
	'block-synced': () => import('@atlaskit/icon-lab/core/block-synced'),
	bluetooth: () => import('@atlaskit/icon-lab/core/bluetooth'),
	blur: () => import('@atlaskit/icon-lab/core/blur'),
	'book-open': () => import('@atlaskit/icon-lab/core/book-open'),
	boolean: () => import('@atlaskit/icon-lab/core/boolean'),
	'browser-extension': () => import('@atlaskit/icon-lab/core/browser-extension'),
	calculate: () => import('@atlaskit/icon-lab/core/calculate'),
	capability: () => import('@atlaskit/icon-lab/core/capability'),
	cart: () => import('@atlaskit/icon-lab/core/cart'),
	'chart-area': () => import('@atlaskit/icon-lab/core/chart-area'),
	'chart-bar-line': () => import('@atlaskit/icon-lab/core/chart-bar-line'),
	'chart-box-plot': () => import('@atlaskit/icon-lab/core/chart-box-plot'),
	'chart-bullet': () => import('@atlaskit/icon-lab/core/chart-bullet'),
	'chart-extrapolate': () => import('@atlaskit/icon-lab/core/chart-extrapolate'),
	'chart-funnel': () => import('@atlaskit/icon-lab/core/chart-funnel'),
	'chart-scatter-plot': () => import('@atlaskit/icon-lab/core/chart-scatter-plot'),
	'cloud-offline': () => import('@atlaskit/icon-lab/core/cloud-offline'),
	'cloud-saved': () => import('@atlaskit/icon-lab/core/cloud-saved'),
	cloud: () => import('@atlaskit/icon-lab/core/cloud'),
	coins: () => import('@atlaskit/icon-lab/core/coins'),
	'colour-none': () => import('@atlaskit/icon-lab/core/colour-none'),
	compare: () => import('@atlaskit/icon-lab/core/compare'),
	'compass-hinged': () => import('@atlaskit/icon-lab/core/compass-hinged'),
	'continue-when': () => import('@atlaskit/icon-lab/core/continue-when'),
	'corner-radius-rounded': () => import('@atlaskit/icon-lab/core/corner-radius-rounded'),
	'corner-radius-squared': () => import('@atlaskit/icon-lab/core/corner-radius-squared'),
	'cross-octagon': () => import('@atlaskit/icon-lab/core/cross-octagon'),
	'cursor-strikethrough': () => import('@atlaskit/icon-lab/core/cursor-strikethrough'),
	cursor: () => import('@atlaskit/icon-lab/core/cursor'),
	'dash-double': () => import('@atlaskit/icon-lab/core/dash-double'),
	'data-app': () => import('@atlaskit/icon-lab/core/data-app'),
	'data-bucket': () => import('@atlaskit/icon-lab/core/data-bucket'),
	'data-formula': () => import('@atlaskit/icon-lab/core/data-formula'),
	'data-function': () => import('@atlaskit/icon-lab/core/data-function'),
	'data-pivot': () => import('@atlaskit/icon-lab/core/data-pivot'),
	'data-transpose': () => import('@atlaskit/icon-lab/core/data-transpose'),
	'data-unpivot': () => import('@atlaskit/icon-lab/core/data-unpivot'),
	'data-visualization-heatmap': () => import('@atlaskit/icon-lab/core/data-visualization-heatmap'),
	'data-visualization-metric': () => import('@atlaskit/icon-lab/core/data-visualization-metric'),
	'data-zero-fill': () => import('@atlaskit/icon-lab/core/data-zero-fill'),
	'database-storage-cache': () => import('@atlaskit/icon-lab/core/database-storage-cache'),
	'database-storage': () => import('@atlaskit/icon-lab/core/database-storage'),
	'diagram-architecture-map': () => import('@atlaskit/icon-lab/core/diagram-architecture-map'),
	'diagram-arrowhead-aggregation-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-aggregation-left'),
	'diagram-arrowhead-aggregation-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-aggregation-right'),
	'diagram-arrowhead-aggregation-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-aggregation-up-right'),
	'diagram-arrowhead-association-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-association-left'),
	'diagram-arrowhead-association-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-association-right'),
	'diagram-arrowhead-association-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-association-up-right'),
	'diagram-arrowhead-circle-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-circle-left'),
	'diagram-arrowhead-circle-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-circle-right'),
	'diagram-arrowhead-circle-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-circle-up-right'),
	'diagram-arrowhead-composition-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-composition-left'),
	'diagram-arrowhead-composition-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-composition-right'),
	'diagram-arrowhead-composition-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-composition-up-right'),
	'diagram-arrowhead-default-flow-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-default-flow-left'),
	'diagram-arrowhead-default-flow-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-default-flow-right'),
	'diagram-arrowhead-default-flow-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-default-flow-up-right'),
	'diagram-arrowhead-inheritance-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-inheritance-left'),
	'diagram-arrowhead-inheritance-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-inheritance-right'),
	'diagram-arrowhead-inheritance-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-inheritance-up-right'),
	'diagram-arrowhead-many-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-many-left'),
	'diagram-arrowhead-many-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-many-right'),
	'diagram-arrowhead-many-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-many-up-right'),
	'diagram-arrowhead-one-left': () => import('@atlaskit/icon-lab/core/diagram-arrowhead-one-left'),
	'diagram-arrowhead-one-or-many-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-one-or-many-left'),
	'diagram-arrowhead-one-or-many-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-one-or-many-right'),
	'diagram-arrowhead-one-or-many-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-one-or-many-up-right'),
	'diagram-arrowhead-one-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-one-right'),
	'diagram-arrowhead-one-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-one-up-right'),
	'diagram-arrowhead-only-one-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-only-one-left'),
	'diagram-arrowhead-only-one-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-only-one-right'),
	'diagram-arrowhead-only-one-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-only-one-up-right'),
	'diagram-arrowhead-sequence-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-sequence-left'),
	'diagram-arrowhead-sequence-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-sequence-right'),
	'diagram-arrowhead-sequence-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-sequence-up-right'),
	'diagram-arrowhead-zero-or-many-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-many-left'),
	'diagram-arrowhead-zero-or-many-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-many-right'),
	'diagram-arrowhead-zero-or-many-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-many-up-right'),
	'diagram-arrowhead-zero-or-one-left': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-one-left'),
	'diagram-arrowhead-zero-or-one-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-one-right'),
	'diagram-arrowhead-zero-or-one-up-right': () =>
		import('@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-one-up-right'),
	'diagram-object-boundary': () => import('@atlaskit/icon-lab/core/diagram-object-boundary'),
	'diagram-object-entity': () => import('@atlaskit/icon-lab/core/diagram-object-entity'),
	'diagram-symbol-action': () => import('@atlaskit/icon-lab/core/diagram-symbol-action'),
	'diagram-symbol-activation': () => import('@atlaskit/icon-lab/core/diagram-symbol-activation'),
	'diagram-symbol-actor': () => import('@atlaskit/icon-lab/core/diagram-symbol-actor'),
	'diagram-symbol-ad-hoc': () => import('@atlaskit/icon-lab/core/diagram-symbol-ad-hoc'),
	'diagram-symbol-alternate-process': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-alternate-process'),
	'diagram-symbol-arrow-left-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-arrow-left-filled'),
	'diagram-symbol-arrow-left': () => import('@atlaskit/icon-lab/core/diagram-symbol-arrow-left'),
	'diagram-symbol-arrow-right-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-arrow-right-filled'),
	'diagram-symbol-arrow-right': () => import('@atlaskit/icon-lab/core/diagram-symbol-arrow-right'),
	'diagram-symbol-assembly': () => import('@atlaskit/icon-lab/core/diagram-symbol-assembly'),
	'diagram-symbol-browser': () => import('@atlaskit/icon-lab/core/diagram-symbol-browser'),
	'diagram-symbol-class': () => import('@atlaskit/icon-lab/core/diagram-symbol-class'),
	'diagram-symbol-cloud': () => import('@atlaskit/icon-lab/core/diagram-symbol-cloud'),
	'diagram-symbol-collaboration': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-collaboration'),
	'diagram-symbol-collate': () => import('@atlaskit/icon-lab/core/diagram-symbol-collate'),
	'diagram-symbol-comment-left': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-comment-left'),
	'diagram-symbol-comment-right': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-comment-right'),
	'diagram-symbol-complex': () => import('@atlaskit/icon-lab/core/diagram-symbol-complex'),
	'diagram-symbol-component-box': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-component-box'),
	'diagram-symbol-component': () => import('@atlaskit/icon-lab/core/diagram-symbol-component'),
	'diagram-symbol-compute': () => import('@atlaskit/icon-lab/core/diagram-symbol-compute'),
	'diagram-symbol-connector-off-page': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-connector-off-page'),
	'diagram-symbol-connector-on-page': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-connector-on-page'),
	'diagram-symbol-container': () => import('@atlaskit/icon-lab/core/diagram-symbol-container'),
	'diagram-symbol-database-source': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-database-source'),
	'diagram-symbol-database': () => import('@atlaskit/icon-lab/core/diagram-symbol-database'),
	'diagram-symbol-decision': () => import('@atlaskit/icon-lab/core/diagram-symbol-decision'),
	'diagram-symbol-delay': () => import('@atlaskit/icon-lab/core/diagram-symbol-delay'),
	'diagram-symbol-display': () => import('@atlaskit/icon-lab/core/diagram-symbol-display'),
	'diagram-symbol-document': () => import('@atlaskit/icon-lab/core/diagram-symbol-document'),
	'diagram-symbol-documents': () => import('@atlaskit/icon-lab/core/diagram-symbol-documents'),
	'diagram-symbol-end': () => import('@atlaskit/icon-lab/core/diagram-symbol-end'),
	'diagram-symbol-error-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-error-filled'),
	'diagram-symbol-error': () => import('@atlaskit/icon-lab/core/diagram-symbol-error'),
	'diagram-symbol-event-based-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-event-based-filled'),
	'diagram-symbol-event-based': () => import('@atlaskit/icon-lab/core/diagram-symbol-event-based'),
	'diagram-symbol-exclusive-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-exclusive-filled'),
	'diagram-symbol-exclusive': () => import('@atlaskit/icon-lab/core/diagram-symbol-exclusive'),
	'diagram-symbol-file': () => import('@atlaskit/icon-lab/core/diagram-symbol-file'),
	'diagram-symbol-fork-horizontal': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-fork-horizontal'),
	'diagram-symbol-fork-vertical': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-fork-vertical'),
	'diagram-symbol-frame': () => import('@atlaskit/icon-lab/core/diagram-symbol-frame'),
	'diagram-symbol-frontend': () => import('@atlaskit/icon-lab/core/diagram-symbol-frontend'),
	'diagram-symbol-hard-disk': () => import('@atlaskit/icon-lab/core/diagram-symbol-hard-disk'),
	'diagram-symbol-history': () => import('@atlaskit/icon-lab/core/diagram-symbol-history'),
	'diagram-symbol-input-output': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-input-output'),
	'diagram-symbol-interface-attributes': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-interface-attributes'),
	'diagram-symbol-internal-storage': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-internal-storage'),
	'diagram-symbol-loop-limit': () => import('@atlaskit/icon-lab/core/diagram-symbol-loop-limit'),
	'diagram-symbol-manual-input': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-manual-input'),
	'diagram-symbol-manual-operation': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-manual-operation'),
	'diagram-symbol-manual': () => import('@atlaskit/icon-lab/core/diagram-symbol-manual'),
	'diagram-symbol-merge': () => import('@atlaskit/icon-lab/core/diagram-symbol-merge'),
	'diagram-symbol-mind-map': () => import('@atlaskit/icon-lab/core/diagram-symbol-mind-map'),
	'diagram-symbol-node': () => import('@atlaskit/icon-lab/core/diagram-symbol-node'),
	'diagram-symbol-note': () => import('@atlaskit/icon-lab/core/diagram-symbol-note'),
	'diagram-symbol-or': () => import('@atlaskit/icon-lab/core/diagram-symbol-or'),
	'diagram-symbol-package': () => import('@atlaskit/icon-lab/core/diagram-symbol-package'),
	'diagram-symbol-parallel-even-based-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-parallel-even-based-filled'),
	'diagram-symbol-parallel-even-based': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-parallel-even-based'),
	'diagram-symbol-parallel-mi': () => import('@atlaskit/icon-lab/core/diagram-symbol-parallel-mi'),
	'diagram-symbol-pin-left-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-pin-left-filled'),
	'diagram-symbol-pin-left': () => import('@atlaskit/icon-lab/core/diagram-symbol-pin-left'),
	'diagram-symbol-pin-right-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-pin-right-filled'),
	'diagram-symbol-pin-right': () => import('@atlaskit/icon-lab/core/diagram-symbol-pin-right'),
	'diagram-symbol-pool-horizontal': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-pool-horizontal'),
	'diagram-symbol-pool-vertical': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-pool-vertical'),
	'diagram-symbol-predefined-process': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-predefined-process'),
	'diagram-symbol-preparation': () => import('@atlaskit/icon-lab/core/diagram-symbol-preparation'),
	'diagram-symbol-provided-interface': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-provided-interface'),
	'diagram-symbol-receive-signal': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-receive-signal'),
	'diagram-symbol-required-interface': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-required-interface'),
	'diagram-symbol-send-signal': () => import('@atlaskit/icon-lab/core/diagram-symbol-send-signal'),
	'diagram-symbol-send': () => import('@atlaskit/icon-lab/core/diagram-symbol-send'),
	'diagram-symbol-shield': () => import('@atlaskit/icon-lab/core/diagram-symbol-shield'),
	'diagram-symbol-signal-filled': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-signal-filled'),
	'diagram-symbol-signal': () => import('@atlaskit/icon-lab/core/diagram-symbol-signal'),
	'diagram-symbol-sort': () => import('@atlaskit/icon-lab/core/diagram-symbol-sort'),
	'diagram-symbol-start': () => import('@atlaskit/icon-lab/core/diagram-symbol-start'),
	'diagram-symbol-stored-data': () => import('@atlaskit/icon-lab/core/diagram-symbol-stored-data'),
	'diagram-symbol-summing-junction': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-summing-junction'),
	'diagram-symbol-swimlanes-horizontal': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-swimlanes-horizontal'),
	'diagram-symbol-swimlanes-vertical': () =>
		import('@atlaskit/icon-lab/core/diagram-symbol-swimlanes-vertical'),
	'diagram-symbol-switch': () => import('@atlaskit/icon-lab/core/diagram-symbol-switch'),
	'diagram-symbol-template': () => import('@atlaskit/icon-lab/core/diagram-symbol-template'),
	'diagram-symbol-terminator': () => import('@atlaskit/icon-lab/core/diagram-symbol-terminator'),
	'diagram-symbol-use-case': () => import('@atlaskit/icon-lab/core/diagram-symbol-use-case'),
	directory: () => import('@atlaskit/icon-lab/core/directory'),
	'distribute-spacing-horizontal': () =>
		import('@atlaskit/icon-lab/core/distribute-spacing-horizontal'),
	'distribute-spacing-vertical': () =>
		import('@atlaskit/icon-lab/core/distribute-spacing-vertical'),
	'divider-element': () => import('@atlaskit/icon-lab/core/divider-element'),
	'dock-toolbar-bottom': () => import('@atlaskit/icon-lab/core/dock-toolbar-bottom'),
	'dock-toolbar-top': () => import('@atlaskit/icon-lab/core/dock-toolbar-top'),
	'dock-window-bottom-left': () => import('@atlaskit/icon-lab/core/dock-window-bottom-left'),
	'dock-window-bottom-right': () => import('@atlaskit/icon-lab/core/dock-window-bottom-right'),
	draw: () => import('@atlaskit/icon-lab/core/draw'),
	'drop-shadow': () => import('@atlaskit/icon-lab/core/drop-shadow'),
	duplicate: () => import('@atlaskit/icon-lab/core/duplicate'),
	editions: () => import('@atlaskit/icon-lab/core/editions'),
	'expand-element': () => import('@atlaskit/icon-lab/core/expand-element'),
	eyedropper: () => import('@atlaskit/icon-lab/core/eyedropper'),
	'field-select': () => import('@atlaskit/icon-lab/core/field-select'),
	'field-text': () => import('@atlaskit/icon-lab/core/field-text'),
	flower: () => import('@atlaskit/icon-lab/core/flower'),
	'folder-shared': () => import('@atlaskit/icon-lab/core/folder-shared'),
	'generative-date': () => import('@atlaskit/icon-lab/core/generative-date'),
	'generative-indicator': () => import('@atlaskit/icon-lab/core/generative-indicator'),
	gift: () => import('@atlaskit/icon-lab/core/gift'),
	'globe-strikethrough': () => import('@atlaskit/icon-lab/core/globe-strikethrough'),
	'group-selection': () => import('@atlaskit/icon-lab/core/group-selection'),
	'group-ungroup-selection': () => import('@atlaskit/icon-lab/core/group-ungroup-selection'),
	group: () => import('@atlaskit/icon-lab/core/group'),
	'hand-closed': () => import('@atlaskit/icon-lab/core/hand-closed'),
	'hand-open': () => import('@atlaskit/icon-lab/core/hand-open'),
	'hand-raised': () => import('@atlaskit/icon-lab/core/hand-raised'),
	'hardware-audit': () => import('@atlaskit/icon-lab/core/hardware-audit'),
	'hardware-configuration': () => import('@atlaskit/icon-lab/core/hardware-configuration'),
	'hardware-defect': () => import('@atlaskit/icon-lab/core/hardware-defect'),
	'hardware-dispose': () => import('@atlaskit/icon-lab/core/hardware-dispose'),
	'hardware-fulfil': () => import('@atlaskit/icon-lab/core/hardware-fulfil'),
	'hardware-new': () => import('@atlaskit/icon-lab/core/hardware-new'),
	'hardware-procure': () => import('@atlaskit/icon-lab/core/hardware-procure'),
	'hardware-refresh': () => import('@atlaskit/icon-lab/core/hardware-refresh'),
	'hardware-repair': () => import('@atlaskit/icon-lab/core/hardware-repair'),
	'hardware-return': () => import('@atlaskit/icon-lab/core/hardware-return'),
	'hardware-ship': () => import('@atlaskit/icon-lab/core/hardware-ship'),
	'hardware-transfer': () => import('@atlaskit/icon-lab/core/hardware-transfer'),
	history: () => import('@atlaskit/icon-lab/core/history'),
	hourglass: () => import('@atlaskit/icon-lab/core/hourglass'),
	'if-else': () => import('@atlaskit/icon-lab/core/if-else'),
	'image-alt-text': () => import('@atlaskit/icon-lab/core/image-alt-text'),
	'image-crop': () => import('@atlaskit/icon-lab/core/image-crop'),
	'image-strikethrough': () => import('@atlaskit/icon-lab/core/image-strikethrough'),
	incognito: () => import('@atlaskit/icon-lab/core/incognito'),
	initiative: () => import('@atlaskit/icon-lab/core/initiative'),
	'jira-add': () => import('@atlaskit/icon-lab/core/jira-add'),
	'jira-upload': () => import('@atlaskit/icon-lab/core/jira-upload'),
	jira: () => import('@atlaskit/icon-lab/core/jira'),
	journeys: () => import('@atlaskit/icon-lab/core/journeys'),
	kanban: () => import('@atlaskit/icon-lab/core/kanban'),
	key: () => import('@atlaskit/icon-lab/core/key'),
	'layout-five-columns': () => import('@atlaskit/icon-lab/core/layout-five-columns'),
	'layout-four-columns': () => import('@atlaskit/icon-lab/core/layout-four-columns'),
	'layout-three-columns-sidebars-left': () =>
		import('@atlaskit/icon-lab/core/layout-three-columns-sidebars-left'),
	'layout-three-columns-sidebars-right': () =>
		import('@atlaskit/icon-lab/core/layout-three-columns-sidebars-right'),
	'link-restricted-access': () => import('@atlaskit/icon-lab/core/link-restricted-access'),
	lozenge: () => import('@atlaskit/icon-lab/core/lozenge'),
	'merge-queue': () => import('@atlaskit/icon-lab/core/merge-queue'),
	'microphone-strikethrough': () => import('@atlaskit/icon-lab/core/microphone-strikethrough'),
	'milestone-complete': () => import('@atlaskit/icon-lab/core/milestone-complete'),
	'milestone-incomplete': () => import('@atlaskit/icon-lab/core/milestone-incomplete'),
	'milestone-multiple': () => import('@atlaskit/icon-lab/core/milestone-multiple'),
	'milestone-overdue': () => import('@atlaskit/icon-lab/core/milestone-overdue'),
	'missed-call': () => import('@atlaskit/icon-lab/core/missed-call'),
	'node-parallel-bottom-left': () => import('@atlaskit/icon-lab/core/node-parallel-bottom-left'),
	'node-parallel-bottom-right': () => import('@atlaskit/icon-lab/core/node-parallel-bottom-right'),
	'node-parallel-top-left': () => import('@atlaskit/icon-lab/core/node-parallel-top-left'),
	'node-parallel-top-right': () => import('@atlaskit/icon-lab/core/node-parallel-top-right'),
	'node-single-left': () => import('@atlaskit/icon-lab/core/node-single-left'),
	'node-single-right': () => import('@atlaskit/icon-lab/core/node-single-right'),
	notepad: () => import('@atlaskit/icon-lab/core/notepad'),
	'page-live-doc': () => import('@atlaskit/icon-lab/core/page-live-doc'),
	'paint-brush': () => import('@atlaskit/icon-lab/core/paint-brush'),
	'paint-roller': () => import('@atlaskit/icon-lab/core/paint-roller'),
	panel: () => import('@atlaskit/icon-lab/core/panel'),
	'party-popper': () => import('@atlaskit/icon-lab/core/party-popper'),
	pencil: () => import('@atlaskit/icon-lab/core/pencil'),
	'person-assignee': () => import('@atlaskit/icon-lab/core/person-assignee'),
	'person-lock-locked': () => import('@atlaskit/icon-lab/core/person-lock-locked'),
	'person-lock-unlocked': () => import('@atlaskit/icon-lab/core/person-lock-unlocked'),
	'person-voiceover': () => import('@atlaskit/icon-lab/core/person-voiceover'),
	'pin-strikethrough': () => import('@atlaskit/icon-lab/core/pin-strikethrough'),
	pipeline: () => import('@atlaskit/icon-lab/core/pipeline'),
	plan: () => import('@atlaskit/icon-lab/core/plan'),
	'playlist-add': () => import('@atlaskit/icon-lab/core/playlist-add'),
	'playlist-added': () => import('@atlaskit/icon-lab/core/playlist-added'),
	'playlist-remove': () => import('@atlaskit/icon-lab/core/playlist-remove'),
	playlist: () => import('@atlaskit/icon-lab/core/playlist'),
	'plus-circle': () => import('@atlaskit/icon-lab/core/plus-circle'),
	'power-cable': () => import('@atlaskit/icon-lab/core/power-cable'),
	power: () => import('@atlaskit/icon-lab/core/power'),
	'qr-code': () => import('@atlaskit/icon-lab/core/qr-code'),
	'queue-pop-in': () => import('@atlaskit/icon-lab/core/queue-pop-in'),
	'queue-pop-out': () => import('@atlaskit/icon-lab/core/queue-pop-out'),
	randomize: () => import('@atlaskit/icon-lab/core/randomize'),
	'registry-service': () => import('@atlaskit/icon-lab/core/registry-service'),
	repeat: () => import('@atlaskit/icon-lab/core/repeat'),
	'reply-left': () => import('@atlaskit/icon-lab/core/reply-left'),
	'reply-right': () => import('@atlaskit/icon-lab/core/reply-right'),
	return: () => import('@atlaskit/icon-lab/core/return'),
	'roadmaps-plan': () => import('@atlaskit/icon-lab/core/roadmaps-plan'),
	'roadmaps-service': () => import('@atlaskit/icon-lab/core/roadmaps-service'),
	rovo: () => import('@atlaskit/icon-lab/core/rovo'),
	'rss-feed': () => import('@atlaskit/icon-lab/core/rss-feed'),
	save: () => import('@atlaskit/icon-lab/core/save'),
	'screen-record': () => import('@atlaskit/icon-lab/core/screen-record'),
	section: () => import('@atlaskit/icon-lab/core/section'),
	service: () => import('@atlaskit/icon-lab/core/service'),
	'shape-diamond': () => import('@atlaskit/icon-lab/core/shape-diamond'),
	'shape-ellipse': () => import('@atlaskit/icon-lab/core/shape-ellipse'),
	'shape-parallelogram-skew-left': () =>
		import('@atlaskit/icon-lab/core/shape-parallelogram-skew-left'),
	'shape-parallelogram-skew-right': () =>
		import('@atlaskit/icon-lab/core/shape-parallelogram-skew-right'),
	'shape-rectangle-rounded': () => import('@atlaskit/icon-lab/core/shape-rectangle-rounded'),
	'shape-rectangle': () => import('@atlaskit/icon-lab/core/shape-rectangle'),
	'shape-triangle-inverted': () => import('@atlaskit/icon-lab/core/shape-triangle-inverted'),
	'shape-triangle': () => import('@atlaskit/icon-lab/core/shape-triangle'),
	signature: () => import('@atlaskit/icon-lab/core/signature'),
	signpost: () => import('@atlaskit/icon-lab/core/signpost'),
	skill: () => import('@atlaskit/icon-lab/core/skill'),
	'skip-unskip': () => import('@atlaskit/icon-lab/core/skip-unskip'),
	skip: () => import('@atlaskit/icon-lab/core/skip'),
	'sort-options': () => import('@atlaskit/icon-lab/core/sort-options'),
	spaces: () => import('@atlaskit/icon-lab/core/spaces'),
	'speedometer-left': () => import('@atlaskit/icon-lab/core/speedometer-left'),
	'speedometer-right': () => import('@atlaskit/icon-lab/core/speedometer-right'),
	'speedometer-up': () => import('@atlaskit/icon-lab/core/speedometer-up'),
	'split-parallel': () => import('@atlaskit/icon-lab/core/split-parallel'),
	stamp: () => import('@atlaskit/icon-lab/core/stamp'),
	'status-workflow-cancelled': () => import('@atlaskit/icon-lab/core/status-workflow-cancelled'),
	'status-workflow-danger': () => import('@atlaskit/icon-lab/core/status-workflow-danger'),
	'status-workflow-in-progress': () =>
		import('@atlaskit/icon-lab/core/status-workflow-in-progress'),
	'status-workflow-in-review': () => import('@atlaskit/icon-lab/core/status-workflow-in-review'),
	'status-workflow-inactive': () => import('@atlaskit/icon-lab/core/status-workflow-inactive'),
	'status-workflow-incomplete': () => import('@atlaskit/icon-lab/core/status-workflow-incomplete'),
	'status-workflow-paused': () => import('@atlaskit/icon-lab/core/status-workflow-paused'),
	'status-workflow-returned': () => import('@atlaskit/icon-lab/core/status-workflow-returned'),
	'status-workflow-scheduled': () => import('@atlaskit/icon-lab/core/status-workflow-scheduled'),
	'status-workflow-stopped': () => import('@atlaskit/icon-lab/core/status-workflow-stopped'),
	'status-workflow-success': () => import('@atlaskit/icon-lab/core/status-workflow-success'),
	'status-workflow-warning': () => import('@atlaskit/icon-lab/core/status-workflow-warning'),
	sticker: () => import('@atlaskit/icon-lab/core/sticker'),
	'stroke-curvature-curved': () => import('@atlaskit/icon-lab/core/stroke-curvature-curved'),
	'stroke-curvature-dynamic': () => import('@atlaskit/icon-lab/core/stroke-curvature-dynamic'),
	'stroke-curvature-straight': () => import('@atlaskit/icon-lab/core/stroke-curvature-straight'),
	'stroke-properties': () => import('@atlaskit/icon-lab/core/stroke-properties'),
	'stroke-style-dashed': () => import('@atlaskit/icon-lab/core/stroke-style-dashed'),
	'stroke-style-dotted': () => import('@atlaskit/icon-lab/core/stroke-style-dotted'),
	'stroke-style-solid': () => import('@atlaskit/icon-lab/core/stroke-style-solid'),
	studio: () => import('@atlaskit/icon-lab/core/studio'),
	'suggested-edit': () => import('@atlaskit/icon-lab/core/suggested-edit'),
	sunset: () => import('@atlaskit/icon-lab/core/sunset'),
	survey: () => import('@atlaskit/icon-lab/core/survey'),
	swap: () => import('@atlaskit/icon-lab/core/swap'),
	'switch-case': () => import('@atlaskit/icon-lab/core/switch-case'),
	sync: () => import('@atlaskit/icon-lab/core/sync'),
	tab: () => import('@atlaskit/icon-lab/core/tab'),
	'table-row-limit': () => import('@atlaskit/icon-lab/core/table-row-limit'),
	'takeout-container': () => import('@atlaskit/icon-lab/core/takeout-container'),
	talent: () => import('@atlaskit/icon-lab/core/talent'),
	'teamwork-graph': () => import('@atlaskit/icon-lab/core/teamwork-graph'),
	telescope: () => import('@atlaskit/icon-lab/core/telescope'),
	'template-sync': () => import('@atlaskit/icon-lab/core/template-sync'),
	template: () => import('@atlaskit/icon-lab/core/template'),
	terminal: () => import('@atlaskit/icon-lab/core/terminal'),
	'text-adjust-length': () => import('@atlaskit/icon-lab/core/text-adjust-length'),
	'text-audio-transcript': () => import('@atlaskit/icon-lab/core/text-audio-transcript'),
	'text-bold-italic-strikethrough': () =>
		import('@atlaskit/icon-lab/core/text-bold-italic-strikethrough'),
	'text-bold-italic-underline-strikethrough': () =>
		import('@atlaskit/icon-lab/core/text-bold-italic-underline-strikethrough'),
	'text-bold-italic-underline': () => import('@atlaskit/icon-lab/core/text-bold-italic-underline'),
	'text-bold-italic': () => import('@atlaskit/icon-lab/core/text-bold-italic'),
	'text-bold-strikethrough': () => import('@atlaskit/icon-lab/core/text-bold-strikethrough'),
	'text-bold-underline-strikethrough': () =>
		import('@atlaskit/icon-lab/core/text-bold-underline-strikethrough'),
	'text-bold-underline': () => import('@atlaskit/icon-lab/core/text-bold-underline'),
	'text-conclusion-add': () => import('@atlaskit/icon-lab/core/text-conclusion-add'),
	'text-cursor': () => import('@atlaskit/icon-lab/core/text-cursor'),
	'text-density-compress': () => import('@atlaskit/icon-lab/core/text-density-compress'),
	'text-density-expand': () => import('@atlaskit/icon-lab/core/text-density-expand'),
	'text-heading-five': () => import('@atlaskit/icon-lab/core/text-heading-five'),
	'text-heading-four': () => import('@atlaskit/icon-lab/core/text-heading-four'),
	'text-heading-one': () => import('@atlaskit/icon-lab/core/text-heading-one'),
	'text-heading-six': () => import('@atlaskit/icon-lab/core/text-heading-six'),
	'text-heading-three': () => import('@atlaskit/icon-lab/core/text-heading-three'),
	'text-heading-two': () => import('@atlaskit/icon-lab/core/text-heading-two'),
	'text-introduction-add': () => import('@atlaskit/icon-lab/core/text-introduction-add'),
	'text-italic-strikethrough': () => import('@atlaskit/icon-lab/core/text-italic-strikethrough'),
	'text-italic-underline-strikethrough': () =>
		import('@atlaskit/icon-lab/core/text-italic-underline-strikethrough'),
	'text-italic-underline': () => import('@atlaskit/icon-lab/core/text-italic-underline'),
	'text-lengthen': () => import('@atlaskit/icon-lab/core/text-lengthen'),
	'text-letter-case': () => import('@atlaskit/icon-lab/core/text-letter-case'),
	'text-normal': () => import('@atlaskit/icon-lab/core/text-normal'),
	'text-paragraph': () => import('@atlaskit/icon-lab/core/text-paragraph'),
	'text-rephrase': () => import('@atlaskit/icon-lab/core/text-rephrase'),
	'text-small': () => import('@atlaskit/icon-lab/core/text-small'),
	'text-subscript': () => import('@atlaskit/icon-lab/core/text-subscript'),
	'text-superscript': () => import('@atlaskit/icon-lab/core/text-superscript'),
	'text-underline-strikethrough': () =>
		import('@atlaskit/icon-lab/core/text-underline-strikethrough'),
	ticket: () => import('@atlaskit/icon-lab/core/ticket'),
	tidy: () => import('@atlaskit/icon-lab/core/tidy'),
	variable: () => import('@atlaskit/icon-lab/core/variable'),
	'vehicle-airplane': () => import('@atlaskit/icon-lab/core/vehicle-airplane'),
	'vehicle-train': () => import('@atlaskit/icon-lab/core/vehicle-train'),
	'video-captions-stylized': () => import('@atlaskit/icon-lab/core/video-captions-stylized'),
	'video-clip': () => import('@atlaskit/icon-lab/core/video-clip'),
	'video-closed-captions-filled': () =>
		import('@atlaskit/icon-lab/core/video-closed-captions-filled'),
	'video-closed-captions': () => import('@atlaskit/icon-lab/core/video-closed-captions'),
	'video-fast-forward-overlay': () => import('@atlaskit/icon-lab/core/video-fast-forward-overlay'),
	'video-fast-forward': () => import('@atlaskit/icon-lab/core/video-fast-forward'),
	'video-hd-filled': () => import('@atlaskit/icon-lab/core/video-hd-filled'),
	'video-hd': () => import('@atlaskit/icon-lab/core/video-hd'),
	'video-miniplayer': () => import('@atlaskit/icon-lab/core/video-miniplayer'),
	'video-overlay-tools': () => import('@atlaskit/icon-lab/core/video-overlay-tools'),
	'video-play-circle': () => import('@atlaskit/icon-lab/core/video-play-circle'),
	'video-record': () => import('@atlaskit/icon-lab/core/video-record'),
	'video-rewind-overlay': () => import('@atlaskit/icon-lab/core/video-rewind-overlay'),
	'video-rewind': () => import('@atlaskit/icon-lab/core/video-rewind'),
	'video-skip-backward-five': () => import('@atlaskit/icon-lab/core/video-skip-backward-five'),
	'video-skip-forward-five': () => import('@atlaskit/icon-lab/core/video-skip-forward-five'),
	'video-strikethrough': () => import('@atlaskit/icon-lab/core/video-strikethrough'),
	'video-theater-mode': () => import('@atlaskit/icon-lab/core/video-theater-mode'),
	'video-timeline-clip-insert-end': () =>
		import('@atlaskit/icon-lab/core/video-timeline-clip-insert-end'),
	'video-timeline-clip-insert-playhead': () =>
		import('@atlaskit/icon-lab/core/video-timeline-clip-insert-playhead'),
	'video-timeline-clip-insert-start': () =>
		import('@atlaskit/icon-lab/core/video-timeline-clip-insert-start'),
	'video-timeline-clip-split': () => import('@atlaskit/icon-lab/core/video-timeline-clip-split'),
	'video-timeline-editor': () => import('@atlaskit/icon-lab/core/video-timeline-editor'),
	'video-watch-later-remove': () => import('@atlaskit/icon-lab/core/video-watch-later-remove'),
	'video-watch-later-saved': () => import('@atlaskit/icon-lab/core/video-watch-later-saved'),
	'view-type-board-home': () => import('@atlaskit/icon-lab/core/view-type-board-home'),
	'view-type-card-home': () => import('@atlaskit/icon-lab/core/view-type-card-home'),
	'view-type-table-home': () => import('@atlaskit/icon-lab/core/view-type-table-home'),
	views: () => import('@atlaskit/icon-lab/core/views'),
	vulnerability: () => import('@atlaskit/icon-lab/core/vulnerability'),
	wallet: () => import('@atlaskit/icon-lab/core/wallet'),
	'warning-outline': () => import('@atlaskit/icon-lab/core/warning-outline'),
	webhook: () => import('@atlaskit/icon-lab/core/webhook'),
	'welcome-feed': () => import('@atlaskit/icon-lab/core/welcome-feed'),
	'work-item-add': () => import('@atlaskit/icon-lab/core/work-item-add'),
	'workflow-controls': () => import('@atlaskit/icon-lab/core/workflow-controls'),
	world: () => import('@atlaskit/icon-lab/core/world'),
	wrench: () => import('@atlaskit/icon-lab/core/wrench'),
};
